export async function trackPageLoad(args: {
  pageType: string
  pageId?: string | null
  panchayatId?: string | null
}) {
  void args
  return null
}
